import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'role'
const plural = 'roles'
const single = 'role'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, params)
		.then(handleResponse)
		.catch(handleError);
}

export default api
